import { get } from 'lodash';

import { Form, Row, Col } from 'react-bootstrap';
import { StateFormGroup } from './StateFormGroup';

export const Address = ({ register, prefix, error, autoFocus = false }) => {
	const namePrefix = prefix ? prefix + '.' : '';

	return (
		<>
			<Form.Group className="mb-3" controlId="formGridAddress1">
				<Form.Label>Address</Form.Label>
				<Form.Control
					type="text"
					autoFocus={autoFocus}
					{...register(namePrefix + 'address')}
				/>
				<Form.Text className="text-danger">
					{get(error, namePrefix + 'address')?.message}
				</Form.Text>
			</Form.Group>

			<Row className="mb-3">
				<Col xs="12" md="4">
					<Form.Group controlId="formGridCity">
						<Form.Label>City</Form.Label>
						<Form.Control {...register(namePrefix + 'city')} />
						<Form.Text className="text-danger">
							{get(error, namePrefix + 'city')?.message}
						</Form.Text>
					</Form.Group>
				</Col>
				<Col xs="6" md="4">
					<Form.Group controlId="formGridState">
						<StateFormGroup
							register={register}
							registerName={namePrefix + 'state'}
							error={error}
						/>
					</Form.Group>
				</Col>

				<Col xs="6" md="4">
					<Form.Group controlId="formGridZip">
						<Form.Label>Zip Code</Form.Label>
						<Form.Control type="number" {...register(namePrefix + 'zip')} />
						<Form.Text className="text-danger">
							{get(error, namePrefix + 'zip')?.message}
						</Form.Text>
					</Form.Group>
				</Col>
			</Row>
		</>
	);
};
